<template>
    <HeaderCardsLayout variant="No-Logo">
        <template #headline>{{ $t('project-series-create') }}</template>
        <template #breadcrumb>
            <Breadcrumb :headline="$t('breadcrumb')" :current-page="$t('project-series-create')">
                <BreadcrumbLink :target="{ name: 'projects' }">
                    <ConstructionIcon class="mr-1 shrink-0" />
                    {{ $t('project-wiki') }}
                </BreadcrumbLink>
            </Breadcrumb>
        </template>
        <template #body>
            <PaddedContentTop>
                <div class="bg-gray-50">
                    <div class="px-4 pb-4 pt-4">
                        <ProjectSeriesCreateForm />
                    </div>
                </div>
            </PaddedContentTop>
        </template>
    </HeaderCardsLayout>
</template>
<script setup lang="ts">
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb.vue';
import BreadcrumbLink from '@/components/Breadcrumb/BreadcrumbLink.vue';
import ConstructionIcon from '@/components/Icon/ConstructionIcon.vue';
import HeaderCardsLayout from '@/components/Layout/HeaderCardsLayout.vue';
import PaddedContentTop from '@/components/Layout/PaddedContentTop.vue';
import { $t } from '@/plugins/fluent';
import { useHeadSafe } from '@unhead/vue';
import ProjectSeriesCreateForm from '../forms/series/ProjectSeriesCreateForm.vue';

useHeadSafe({ title: () => `${$t('project-series-create')} - ${$t('project-wiki')}` });
</script>
